export enum IblErrorCode {
  WRONG_IBL_FORMAT,
  MAX_KKS_COUNT_EXCEEDED,
}
